import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiteLaunchService } from '../../../core/services/site-launch.service';
import { Observable } from 'rxjs';
import { LAUNCH_MODAL_TRANSLATIONS } from './launch-modal.translations';

@Component({
  selector: 'app-launch-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './launch-modal.component.html',
  styleUrls: ['./launch-modal.component.scss']
})
export class LaunchModalComponent implements OnInit, OnDestroy {
  isVisible$: Observable<boolean>;
  // Countdown state
  timeLeft = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  isLaunched = false;
  isZoomingOut = false;
  private timerInterval: any;
  private launchTimeout: any;
  private zoomTimeout: any;

  currentLang = 'or';

  @HostListener('window:langChange', ['$event'])
  onLangChange(event: CustomEvent) {
    this.currentLang = event.detail;
  }

  get t(): any {
    return LAUNCH_MODAL_TRANSLATIONS[this.currentLang] || LAUNCH_MODAL_TRANSLATIONS['en'];
  }

  constructor(public launchService: SiteLaunchService) {
    this.isVisible$ = this.launchService.modalVisible$;
  }

  ngOnInit(): void {
    const savedLang = localStorage.getItem('app_lang');
    if (savedLang) {
      this.currentLang = savedLang;
    }

    this.updateCountdown();
    this.timerInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.timerInterval) clearInterval(this.timerInterval);
    if (this.launchTimeout) clearTimeout(this.launchTimeout);
    if (this.zoomTimeout) clearTimeout(this.zoomTimeout);
  }

  private updateCountdown(): void {
    const now = new Date().getTime();
    const target = new Date(this.launchService.LAUNCH_DATE).getTime();
    const difference = target - now;

    if (difference <= 0) {
      if (!this.isLaunched) {
        this.isLaunched = true;
        this.timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        
        // Wait for flowers to animate and user to see the "Registration Open" message
        this.launchTimeout = setTimeout(() => {
          this.isZoomingOut = true;
          // Wait for the CSS zoom out animation to finish before removing from DOM
          this.zoomTimeout = setTimeout(() => {
            this.closeModal();
            this.isZoomingOut = false; // Reset for next time if needed
          }, 600);
        }, 4000);
      }
    } else {
      // If the target is in the future, ensure it's not marked as launched
      if (this.isLaunched) {
        this.isLaunched = false;
        this.isZoomingOut = false;
        if (this.launchTimeout) clearTimeout(this.launchTimeout);
        if (this.zoomTimeout) clearTimeout(this.zoomTimeout);
      }
      
      this.timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((difference % (1000 * 60)) / 1000)
      };
    }
  }

  closeModal(): void {
    this.launchService.hideModal();
  }
}
